<template>
  <div>
    <Dialog
      :model-value="isOpen"
      :show-icon="null"
      :persistent="true"
      max-width="800px"
      :content-class="'patient-picker-dialog'"
      @update:model-value="tryCloseCreationWindow"
    >
      <template
        v-if="isOpen"
        #content
      >
        <div class="dialog-title">
          {{ t('Create new patient') }}
        </div>
        <PatientCreation
          ref="patientCreation"
          @save="saveNewPatient"
          @cancel="closeCreationWindow"
        />
      </template>
      <template #actions>
        <div />
      </template>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Dialog from '@/components/dialogs/Dialog.vue'
import PatientCreation from '@/components/patients/PatientCreation.vue'
import { usePhysiciansStore } from '@/stores/physicians'
import { usePatientsStore } from '@/stores/patients'
import { Patient } from '@/entities/patient'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const isOpen = ref(false)
const physicianStore = usePhysiciansStore()
const patientStore = usePatientsStore()

const physicianId = () => physicianStore.getPhysician?.userId ?? ''
const patientCreation = ref<InstanceType<typeof PatientCreation> | null>(null)

function openCreationWindow() {
  isOpen.value = true
}

function closeCreationWindow() {
  isOpen.value = false
}

function tryCloseCreationWindow(value: boolean) {
  if (!value && patientCreation.value) {
    patientCreation.value.cancel()
  }
}

async function saveNewPatient(patient: Patient) {
  await patientStore.postPatient(patient, physicianId())
  closeCreationWindow()
  emit('selectNewPatient')
}

const emit = defineEmits<{
  (e: 'selectNewPatient'): void
}>()

defineExpose({
  openCreationWindow
})
</script>
